import { ReactNode } from 'react';
import { Box, Divider, FelaCSS } from '@bridebook/ui';
import mergeStyles from '@bridebook/ui/src/fela-utils/merge-styles';
import componentStyles from './accordion-sections.style';

export const AccordionSections = ({
  children,
  style,
  id,
}: {
  children: ReactNode;
  style?: FelaCSS;
  id?: string;
}) => {
  const styles = componentStyles();

  return (
    <Box style={mergeStyles([styles.wrapper, style || {}])} id={id}>
      <Divider />
      {children}
    </Box>
  );
};
